const isResolvedResource = require('../contentful/is-resolved-resource');
const campaignTransformer = require('./campaign');

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    // console.log('color', entry);
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,

      name: entry.fields.name['nb-NO'],
      primary: (entry.fields.primary ? entry.fields.primary['nb-NO'] : null),
      overrideIndex: entry.fields.overridePosition ? entry.fields.overridePosition['nb-NO'] : null,
      startDate: new Date(entry.fields.startDate['nb-NO']),
      expiryDate: new Date(entry.fields.expiryDate['nb-NO']),
      campaign: null
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    // Handle model link:
    if (entry.fields.campaign && entry.fields.campaign['nb-NO'] && isResolvedResource(entry.fields.campaign['nb-NO'])) {
      result.campaign = campaignTransformer.contentfulToInternal(entry.fields.campaign['nb-NO']);
    }

    return result;
  },

  internalToContentful(override) {
    const result = {
      fields: {
        name: {
          'nb-NO': override.name
        },
        overridePosition: {
          'nb-NO': (override.overrideIndex !== undefined && !override.primary) ? parseInt(override.overrideIndex, 10) : undefined
        },
        primary: {
          'nb-NO': override.primary
        },
        startDate: {
          'nb-NO': override.startDate.toISOString()
        },
        expiryDate: {
          'nb-NO': override.expiryDate.toISOString()
        }
      }
    };

    if (typeof override.campaign !== 'undefined') {
      result.fields.campaign = {
        'nb-NO': override.campaign ? createEntryLink(override.campaign) : null
      };
    }

    return result;
  }
};
